import { type ReactNode } from "react";
import { cn } from "@/shared/lib/utils";
import { Spinner } from "@/shared/components/ui/spinner";

interface KpiCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon: ReactNode;
  loading?: boolean;
  accent?: "default" | "success" | "warning" | "danger" | "info";
}

const accentValue: Record<string, string> = {
  default: "text-foreground",
  success: "text-green-600",
  warning: "text-amber-600",
  danger: "text-red-600",
  info: "text-blue-600",
};

export const KpiCard = ({
  title,
  value,
  subtitle,
  icon,
  loading,
  accent = "default",
}: KpiCardProps) => (
  <div className="rounded-xl border bg-card p-5 shadow-sm">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-muted-foreground">
          {title}
        </p>
        {loading ? (
          <div className="mt-2">
            <Spinner className="size-5" />
          </div>
        ) : (
          <p
            className={cn(
              "mt-1 text-2xl font-semibold tracking-tight",
              accentValue[accent],
            )}
          >
            {value}
          </p>
        )}
        {subtitle && (
          <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
        )}
      </div>
      <div className="shrink-0 rounded-lg bg-secondary p-2 text-muted-foreground">
        {icon}
      </div>
    </div>
  </div>
);
